import { useCallback } from 'react';
import {
  discoveryApiRef,
  fetchApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';

import { AsyncSelectField, SelectOption } from '../common/AsyncSelectField';
import { fetchAdoResource } from '../common/adoResourcesApi';

type AzureDevOpsProject = {
  id: string;
  name: string;
};

export const AzureDevOpsProjectPicker = ({
  onChange,
  formData,
  required,
  rawErrors,
  schema,
}: FieldExtensionComponentProps<string>) => {
  const discoveryApi = useApi(discoveryApiRef);
  const fetchApi = useApi(fetchApiRef);

  const loadProjects = useCallback(async (): Promise<SelectOption[]> => {
    const projects = await fetchAdoResource<AzureDevOpsProject[]>(
      discoveryApi,
      fetchApi,
      '/projects',
    );

    return projects.map(project => ({
      value: project.name,
      label: project.name,
    }));
  }, [discoveryApi, fetchApi]);

  return (
    <AsyncSelectField
      label={schema.title ?? 'Azure DevOps Project'}
      description={schema.description}
      value={formData}
      required={required}
      rawErrors={rawErrors}
      onChange={onChange}
      loadOptions={loadProjects}
      loadingText="Loading projects..."
      emptyText="Select a project"
    />
  );
};
